import { use } from 'react';
import { ModalDialogContext } from './modals-dialogs-context';
/**
 * Whether a modal or dialog of the surrounding `ModalDialogProvider` is open. A drawer rendered with
 * plain markup rather than `useDrawer` passes this to the MF `Drawer`'s `aboveModals`, so opened from
 * inside a modal it paints in front of that modal instead of behind its backdrop.
 * @returns True while a modal or dialog is open; false for drawers alone and outside a provider
 */
export const useHasOpenModalDialog = () => {
    var _a;
    const context = use(ModalDialogContext);
    return (_a = context === null || context === void 0 ? void 0 : context.modalDialogs.some(item => item.open && item.type !== 'drawer')) !== null && _a !== void 0 ? _a : false;
};
